import { apiClient } from './api';
import {
  AuditLogEntry,
  AuditLogResponse,
  AuditStats,
  AuditLogFilters,
} from '@/types';

export class AuditService {
  /**
   * Get recent activities for the current user
   * Used by the dashboard recent activity feed
   * Returns only the user's own activities
   */
  static async getRecentActivities(limit: number = 5): Promise<AuditLogEntry[]> {
    const url = `/audit-logs/recent?limit=${limit}`;
    return apiClient.get<AuditLogEntry[]>(url);
  }

  /**
   * Get paginated audit logs with filters
   * Admin only - requires SYSTEM_ADMIN or SUPER_ADMIN role
   */
  static async getAuditLogs(filters: AuditLogFilters = {}): Promise<AuditLogResponse> {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });

    const queryString = params.toString();
    const url = queryString ? `/audit-logs?${queryString}` : '/audit-logs';

    return apiClient.get<AuditLogResponse>(url);
  }

  /**
   * Get audit statistics for dashboard
   */
  static async getAuditStats(startDate?: string, endDate?: string): Promise<AuditStats> {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    const queryString = params.toString();
    const url = queryString ? `/audit-logs/stats?${queryString}` : '/audit-logs/stats';

    return apiClient.get<AuditStats>(url);
  }

  /**
   * Export audit logs as CSV (future implementation)
   */
  static async exportAuditLogs(filters: AuditLogFilters = {}): Promise<Blob> {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });

    const queryString = params.toString();
    const url = queryString ? `/audit-logs/export?${queryString}` : '/audit-logs/export';

    return apiClient.download(url);
  }
}
